var _style, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 726.1 85",
    style: {
      enableBackground: "new 0 0 726.1 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#CA0928;}.st1{font-family:'AudiType-ExtendedBold';}.st2{font-size:77.1689px;}.st3{letter-spacing:-1;}.st4{letter-spacing:-2;}.st5{font-family:'AudiType-ExtendedNormal';}")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 0 66.5195)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st0 st1 st2 st3"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 70,
    y: 0,
    className: "st0 st1 st2 st3"
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    x: 129.7,
    y: 0,
    className: "st0 st1 st2 st4"
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    x: 190.1,
    y: 0,
    className: "st0 st1 st2"
  }, "i"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 216.4609 66.5195)",
    className: "st1 st2"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 242.0039 66.5195)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st5 st2 st4"
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 52.6,
    y: 0,
    className: "st5 st2 st3"
  }, "\xF6"), /*#__PURE__*/React.createElement("tspan", {
    x: 109.2,
    y: 0,
    className: "st5 st2"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 149.5,
    y: 0,
    className: "st5 st2 st3"
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 197.6,
    y: 0,
    className: "st5 st2 st3"
  }, "\xE4"), /*#__PURE__*/React.createElement("tspan", {
    x: 251.2,
    y: 0,
    className: "st5 st2"
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 303.5,
    y: 0,
    className: "st5 st2 st3"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 342.8,
    y: 0,
    className: "st5 st2 st4"
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 365.8,
    y: 0,
    className: "st5 st2 st3"
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 424.2,
    y: 0,
    className: "st5 st2"
  }, "g"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudi);
export default __webpack_public_path__ + "static/media/audi.38404c999b156bbd99ecdee21c314b79.svg";
export { ForwardRef as ReactComponent };